import contractsService from "@/services/contractsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await contractsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Mietvertrag wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietvertrag konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async back({ dispatch }, formData) {
    try {
      await contractsService.back(formData);
      dispatch(
        "common/showSuccess",
        "Mietvertrag zurück wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietvertrag zurück konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async cancel({ dispatch }, formData) {
    try {
      await contractsService.cancel(formData);
      dispatch(
        "common/showSuccess",
        "Mietvertrag wurde erfolgreich storniert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietvertrag konnte nicht storniert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await contractsService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietverträge für diese Buchung konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getAttachement({ dispatch }, formData) {
    try {
      const res = await contractsService.getAttachement(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietvertrag-PDF für diese Buchung konnte nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getDigitalSignatureContractsNotPrinted({ dispatch }) {
    try {
      const res = await contractsService.getDigitalSignatureContractsNotPrinted();
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Digital signierte Verträge konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async setIsPrintedOnPaper({ dispatch }, formData) {
    try {
      const res = await contractsService.setIsPrintedOnPaper(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "'Gedruckt' konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await contractsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Mietvertrag wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietvertrag für diese Buchung konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async search({ dispatch }, payload) {
    try {
      const res = await contractsService.search(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Verträge konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
